import { useAppSelector } from "@/app/store";
import type { ThemeMode } from "@/config/themes/types";
import { selectAppearancePreference } from "@/features/appearance/model/appearanceSlice";

export function useResolvedThemeMode(): ThemeMode {
  return useAppSelector(selectAppearancePreference);
}
